const useRoute = () => {
  return typeof window !== 'undefined' ? window.location.pathname : null
}

export default useRoute
